import "./index.sass";

import GewobagGallery from "./js/gewobag-gallery.js";
import MarketplaceFilter from "./js/marketplace-filter.js";
import RatingStars from "./js/rating-stars.js";
import {initIrDisclaimer} from "./js/ir-disclaimer";

const galleries = document.querySelectorAll('.js-gallery');
galleries.forEach(gallery => {
	new GewobagGallery(gallery);
});

const filterForm = document.querySelector('.gw-filter-group');
if (filterForm) new MarketplaceFilter(filterForm);

const ratingComponents = document.querySelectorAll('.js-gw-rating-stars');
ratingComponents.forEach((ratingComponent) => {
	new RatingStars(ratingComponent);
});

initIrDisclaimer();
